import { render, staticRenderFns } from "./kitora.vue?vue&type=template&id=588f008c&"
import script from "./kitora.vue?vue&type=script&lang=js&"
export * from "./kitora.vue?vue&type=script&lang=js&"
import style0 from "./kitora.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports